// extracted by mini-css-extract-plugin
export default {"orb":"styles_orb__9QOp2","orbSwirl":"styles_orbSwirl__w1LnG"};